// extracted by mini-css-extract-plugin
export default {"inputTitle":"input-title_inputTitle__eRMFi"};